// appels/programme: step 1 « Programme et places », the six texts the applicants will read.
import type { BilingualText } from "@core/components";
import type { Appel } from "../../_shared/types";

export const TEXT_FIELDS = ["presentation", "rhythm", "location"] as const;
export type TextField = (typeof TEXT_FIELDS)[number];

export type ProgrammeValues = Record<TextField, BilingualText>;

/** The form for a saved appel (empty texts for a new one). */
export function valuesOfAppel(appel: Appel): ProgrammeValues {
  return {
    presentation: { ...appel.presentation },
    rhythm: { ...appel.rhythm },
    location: { ...appel.location },
  };
}

/** `field.language` to the code of what is wrong, e.g. `presentation.en: "required"`. */
export type ProgrammeErrors = Partial<
  Record<`${TextField}.${"fr" | "en"}`, "required">
>;

/**
 * All six texts are required, each in its own language, and blank counts as missing (the API
 * trims). « Suivant » shows every missing one at once, each under its own field.
 */
export function validateProgramme(values: ProgrammeValues): ProgrammeErrors {
  const errors: ProgrammeErrors = {};
  for (const field of TEXT_FIELDS) {
    if (values[field].fr.trim() === "") errors[`${field}.fr`] = "required";
    if (values[field].en.trim() === "") errors[`${field}.en`] = "required";
  }
  return errors;
}

/** The request body, minus the revision (the hook adds it). */
export function toProgrammeRequest(
  values: ProgrammeValues
): Record<TextField, BilingualText> {
  const trim = (text: BilingualText): BilingualText => ({
    fr: text.fr.trim(),
    en: text.en.trim(),
  });
  return {
    presentation: trim(values.presentation),
    rhythm: trim(values.rhythm),
    location: trim(values.location),
  };
}
